module.exports = __webpack_public_path__ + "static/CustomBar-3f01ecc845076354dbb78d74f8537e65.svg";